import Axios from '../context/axios/AxiosControl'

export const getOrdersForDelivery = (estadoPago = "", page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/order/getfordelivery/?statusPago='+estadoPago, { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersDelivered = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/order/getdelivered/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersClient = (idClient) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/order/getbyclient/' + idClient, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersClientDelivered = (idClient, page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/order/getdeliveredclient/' + idClient, { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersClientToDelivery = (idClient) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/order/getfordeliveryclient/' + idClient, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersRestaurantDelivered = (idRestaurant, page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/order/getdeliveredrestaurant/' + idRestaurant, { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrdersRestaurantToDelivery = (idRestaurant) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/order/getfordeliveryrestaurant/' + idRestaurant, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        console.log(data)
        if (status === 200) {
            dispatch({
                type: 'ORDER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getOrder = (order) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/order/get/'+ order, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GET_SUCCESS',
                payload: data.order
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const addOrder = (orderdata) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/restaurant/order/register', orderdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'ORDER_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'ORDER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const editOrder = (orderdata, idOrder) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/order/edit/' + idOrder, orderdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'ORDER_EDIT_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'ORDER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_ERROR'
        })
    }
}

export const removeOrder = (orderId) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.delete(`/api/restaurant/order/remove/${orderId}`, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_REMOVE_SUCCESS',
                payload: {id: orderId, message: data.message}
            })
            dispatch({
                type: 'ORDER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const changeToDelivered = (idOrder, type = null) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/order/todelivered/' + idOrder, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            if(type && type === 'kitchen'){
                dispatch({
                    type: 'ORDER_EDITSTATEKITCHEN_SUCCESS',
                    payload: data
                })
            }else{
                if(type && type === 'admin'){
                    dispatch({
                        type: 'ORDER_EDITSTATEADMIN_SUCCESS',
                        payload: data
                    })
                }else{
                    dispatch({
                        type: 'ORDER_EDITSTATE_SUCCESS',
                        payload: data
                    })
                }
            }
            dispatch({
                type: 'ORDER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_ERROR'
        })
    }
}

export const changeToDelivery = (idOrder, type = null) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/order/todelivery/' + idOrder, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            if(type && type === 'kitchen'){
                dispatch({
                    type: 'ORDER_EDITSTATEKITCHEN_SUCCESS',
                    payload: data
                })
            }else{
                if(type && type === 'admin'){
                    dispatch({
                        type: 'ORDER_EDITSTATEADMIN_SUCCESS',
                        payload: data
                    })
                }else{
                    dispatch({
                        type: 'ORDER_EDITSTATE_SUCCESS',
                        payload: data
                    })
                }
            }
            dispatch({
                type: 'ORDER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_ERROR'
        })
    }
}

export const changeToPrinted = (idOrder, type = null) => async (dispatch) => {
    try {
        await Axios.put('/api/restaurant/order/toprinted/' + idOrder, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
    } catch (error) {
        dispatch({
            type: 'ORDER_ERROR'
        })
    }
}

// export const addPaymentIntent = (orderId, paymentIntent) => async (dispatch) => {
//     dispatch({
//         type: 'ORDER_LOADING'
//     })
//     try {
//         await Axios.put(`api/restaurant/order/${orderId}/addPaymentIntent`, {
//             paymentId: paymentIntent
//         }, {
//             headers: {
//                 auth: localStorage.getItem('jwt')
//             }
//         })
//     } catch (error) {
//         dispatch({
//             type: 'ORDER_ERROR'
//         })
//     }
// }

export const payOrder = (order) => async(dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const {status} = await Axios.put(`/api/restaurant/order/${order}/pay`, {}, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })

        if (parseInt(status) === 200) {
            dispatch({type: 'ORDER_PAY_SUCCESS'})
        } else {
            dispatch({
                type: 'ORDER_ERROR'
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_ERROR'
        })
    }
}

export const getPaymentFormParams = (orderId) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/payment/createPaymentForm/'+ orderId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ORDER_GET_PAYMENT_FORM_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}

export const getPaymentStatus = (orderId) => async (dispatch) => {
    dispatch({
        type: 'ORDER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/order/getStatus/'+ orderId)
        if (status === 200) {
            dispatch({
                type: 'ORDER_GET_PAYMENT_STATUS_SUCCESS',
                payload: data?.status
            })
        }
    } catch (error) {
        dispatch({
            type: 'ORDER_NOT_LOADING'
        })
    }
}